import axios from 'axios';
import { useEffect, useState } from 'react';
import language from '../../variables/language';
import Selector from '../../components/forms/Selector';
import Select from '../../components/solid-forms/Select';
import { div } from 'framer-motion/client';
import IconGoBack from '../../components/icons/IconGoBack';
import { DateTime } from 'luxon';

export default function ConversationsMenu({clientId, openTriger, closeCallback}) {

    const [conversations, setConverstions] = useState([]);
    const [conversationType, setConversationType] = useState(3);
    const [conversationTypes, setConversationTypes] = useState([]);
    const [displayModal, setDisplayModal] = useState('none');

    useEffect(()=> {
        getConversationTypes();
    }, [clientId]);


    useEffect(()=> {
        getConversations();
    }, [conversationType]);

    useEffect(() => {
        if (openTriger) {
            setDisplayModal('block');
        } else {
            setDisplayModal('none');
        }
    },[openTriger])

    const handleInputChange = (value, fieldName) => {
        setConversationType(value);
    }

    const getConversations = () => {
        let url = '/api/conversations?type='+conversationType;
        axios.get(url,{withCredentials:true})
            .then(response => setConverstions(response.data))
            .catch(err => console.error(err));
    }

    const getConversationTypes = () => {
        let url = '/api/conversationtypes';
        axios.get(url,{withCredentials:true})
            .then(response => setConversationTypes(response.data))
            .catch(err => console.error(err));
    }

    const addChosenConversation = (item) => {

        let formData = {
            client : clientId,
            conversationId :  item.id
        }

        if (window.confirm(`Хочеш додати клієнту розмову ${item.name}?`)) {
            axios.post('/api/conversationprogress',
                JSON.stringify(formData),
                {  
                    withCredentials: true,
                   headers: {
                       'Content-Type': 'application/json',
                   }
                })
                .then(response => closeCallback(false))
                .catch(err => console.error(err));
        }

    }


    return(
        <div className=' modal-menu' style={{display:displayModal}} >
            <div className='solid-modal-container'>
                <div className='solid-modal-header'>
                    <div className='txt-c header-solid-modal'>Обери розмову щоб додати клієнту</div>
                    <div className='solid-modal-header-func'>
                    <Select options={conversationTypes} info={language[language.lang]['conversationTypes'] } 
                        handleInputChange={handleInputChange} 
                        className={'submit-field form-selection txt-c select-modal'}
                            fieldName={'name'} disabled={false} value={0} 
                            inputName={'conversationtype'} />
                    <IconGoBack onClick={(e) => closeCallback(false)} fillColor={'icon-red'} />
                    </div>

                </div>
                <div className='conversation-plate-container scrooll' key={conversationType}>
                    {
                        conversations.map(item => (
                            <div key={item.id} onClick={(e) => addChosenConversation(item)}
                             className='conversation-plate grid-plate-item cursor-pointer' >
                                <div className='grid-plate-header' >
                                    <p className='txt-c grid-plate-name'>{item.name}</p>
                                    <p className=' secondary-txt txt-c ' >{item.level ? item.level.name : ''}</p>
                                </div>
                                <div className='grid-plate-body'>
                                    <p className='txt-c grid-plate-description' >{item.description}</p>
                                    {item.hashCode ? <p className='txt-c ' > <span>Код:</span> {item.hashCode}</p>  : ''}
                                    {item.estimationFunction ? <p className='txt-c ' ><span>Функція:</span>{item.estimationFunction.name}</p> : ''}
                                    {item.stageTypeId ? <p className='txt-c ' ><span>Конвеєр:</span>{item.stageTypeId.name}</p> : ''}
                                </div>


                                
                                
                                <p className='txt-c timestamp'>{DateTime.fromISO(item.dAdd, { setZone: true }).toFormat("HH:mm dd.MM.yyyy ")}</p>
                                
                                
                            </div>
                        ))
                    }

                </div>
            </div>

        </div>

        
    )

}